import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import "./index.css";

const existingToken = sessionStorage.getItem("token");
if (existingToken) {
    sessionStorage.removeItem("token");
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
